export const ROUTE_BASE = '';

//Components
export const ROUTE_PAGE_MESSAGE = '/pageMessage';

//Login Pages
export const ROUTE_PAGE_LOGIN = '/pageLogin';
export const ROUTE_PAGE_LOGOUT = '/pageLogout';
export const ROUTE_PAGE_MEMBER_LOGIN = '/pageMemberLogin';
export const ROUTE_PAGE_WEB_LOGIN = '/pageWebLogin';
export const ROUTE_PAGE_AUTHENTICATED = '/pageAuthenticated';
export const ROUTE_PAGE_PASSWORD_LESS_SAML_SUBMIT = '/pagePasswordLessSamlSubmit';
export const ROUTE_PAGE_EULA = '/pageEula';
export const ROUTE_PAGE_PROFILE = '/pageProfile';
export const ROUTE_PAGE_CONFIRM_CONTACT = '/pageConfirmContact';
export const ROUTE_PAGE_USERINFO = '/pageUserInfo';
export const ROUTE_PAGE_WEBAUTHNREG = '/pageWebAuthnRegister';
export const ROUTE_PAGE_WEBAUTHNAUTH = '/pageWebAuthnAuth';
export const ROUTE_PAGE_WEBAUTHNDEVICES = '/pageWebAuthnDevices';
export const ROUTE_PAGE_SAML_MESSAGE = '/pageSamlMessage';
export const ROUTE_PAGE_WSFED_MESSAGE = '/pageWsFedMessage';
export const ROUTE_PAGE_SAML_TFA = '/pageSamlTfa';
export const ROUTE_PAGE_APP_USER_LOGIN_TFA = '/pageAppUserLoginTfa';
export const ROUTE_PAGE_SAML_CHOOSE_APP = '/pageSamlChooseApp';
export const ROUTE_PAGE_NOT_AUTHORIZED = '/pageNotAuthorized';
export const ROUTE_PAGE_MAX_SESSIONS_EXCEED = '/pageMaxSessionsExceed';
export const ROUTE_PAGE_USER_HAS_EXISTING_SESSIONS = '/pageExistingSessions';
export const ROUTE_PAGE_CHANGE_EMAIL = '/pageChangeEmail';


//Password Pages
export const ROUTE_PAGE_FORGOT_PASSWORD = '/pageForgotPassword';
export const ROUTE_PAGE_CHANGE_PASSWORD = '/pageChangePassword';

//Global ID Pages
export const ROUTE_PAGE_REQUEST_GLOBAL_ID = '/pageRequestGlobalId';
export const ROUTE_PAGE_REGISTER_GLOBAL_ID_WITH_COMPANY = '/pageRegisterGlobalIdWithCompany';
export const ROUTE_PAGE_CONFIRM_USER_EMAIL = '/pageConfirmUserEmail';

//TFA Pages
export const ROUTE_PAGE_TFA_HELP = '/pageTfaHelp';
export const ROUTE_PAGE_TFA_REGISTER = '/pageTfaRegister';
export const ROUTE_PAGE_TFA_EMAIL_REGISTER = '/pageTfaEmailRegister';
export const ROUTE_PAGE_TFA_REGISTRATION_DONE = '/pageTfaRegistrationDone';
export const ROUTE_PAGE_UPDATE_TFA_LOGIN = '/pageUpdateTfaLogin';
export const ROUTE_PAGE_REGISTER_LOGIN = '/pageRegisterLogin';
export const ROUTE_PAGE_EMAIL_PASSCODE = '/pageEmailPasscode';

//Servlets
export const ROUTE_FORGOT_PASSWORD_SERVLET = '/forgotPassword';
export const ROUTE_CHANGE_PASSWORD_SERVLET = '/changeUserPassword';
export const ROUTE_REQUEST_GLOBAL_ID_SERVLET = '/requestGlobalId';
export const ROUTE_REGISTER_GLOBAL_ID_WITH_COMPANY_SERVLET = '/registerGlobalId';
export const ROUTE_CONFIRM_USER_EMAIL_SERVLET = '/confirmUserEmail';
export const ROUTE_APP_USER_LOGIN_SERVLET = '/appUserLogin';
export const ROUTE_APP_USER_RELOGIN_SERVLET = '/appUserRelogin';
export const ROUTE_MEMBER_LOGIN_SERVLET = '/memberLogin';
export const ROUTE_MEMBER_APP_LOGIN_SERVLET = '/getMemberLoginApps';
export const ROUTE_PAGE_UPDATE_REGISTRATION = '/updateRegistration';

//APIs
export const API_BASE = 'api';
export const API_APP_UI_MSGS = API_BASE + '/getAppUiMessages';
export const API_APP_BRAND_CONFIG = API_BASE + '/getAppBrandConfig';

//Login
export const API_AUTHENTICATE_TFA = API_BASE + '/authenticateTfa';
export const API_AUTHENTICATE_GLOBAL = API_BASE + '/authenticateGlobalId';
export const API_AUTHENTICATE_LAUNCHER = API_BASE + '/authenticateLauncher';
export const WEBAUTHN_GET_TFA_REQUEST = API_BASE + '/webauthnGetTfaRequest';

//2FA
export const API_GET_TFA_DETAILS = API_BASE + '/getTfaDetails';
export const API_GET_TFA_DETAILS_AUTHENTICATED = API_BASE + '/getTfaDetailsAuthenticated';
export const API_AUTH_AND_SEND_CODE_TO_2FA_EMAIL = API_BASE + '/authAndSendCodeTo2FAEmail';
export const API_VERIFY_N_SAVE_TFA_DETAILS = API_BASE + '/VerifyNSaveTfaDetails';
export const API_VERIFY_N_SAVE_TFA_DETAILS_AUTHENTICATED = API_BASE + '/VerifyNSaveTfaAuthenticated';
export const API_EMAIL_VERIFICATION_CODE = API_BASE + '/emailVerificationCode';
export const API_VERIFY_VERIFICATION_CODE = API_BASE + '/verifyEmailAndRegister';
export const API_EMAIL_VERIFICATION_CODE_AUTHENTICATED = API_BASE + '/emailVerificationCodeAuthenticated';
export const API_VERIFY_TFA_PASSCODE_AUTHENTICATED = API_BASE + '/verifyTfaPasscodeAuthenticated';
export const API_GET_TFA_QR_CODE_AUTHENTICATED = API_BASE + '/getTfaQrCodeAuthenticated';
export const API_VERIFY_TFA_QR_CODE_AUTHENTICATED = API_BASE + '/verifyTfaPasscodeAuthenticated';
export const API_WEBAUTHN_STARTREGISTRATION = API_BASE + '/webauthnStartRegistration';
export const API_WEBAUTHN_FINISHREGISTRATION = API_BASE + '/webauthnFinishRegistration';
export const API_WEBAUTHN_STARTASSERTION = API_BASE + '/webauthnStartAssertion';
export const API_WEBAUTHN_FINISHASSERTION = API_BASE + '/webauthnFinishAssertion';
export const API_GET_WEBAUTHN_REGISTRATIONS = API_BASE + '/getWebAuthnRegistrations';
export const API_DELETE_WEBAUTHN_REGISTRATION = API_BASE + '/deleteWebAuthnRegistration';
export const API_GET_AUTHENTICATOR_DEVICES = API_BASE + '/getAuthenticatorDevices';
export const API_DELETE_AUTHENTICATOR_DEVICE = API_BASE + '/deleteAuthenticatorDevice';

//Logout
export const API_LOGOUT_USERTOKEN = API_BASE + '/logoutUserToken';
export const API_LOGOUT_USERSESSIONS = API_BASE + '/logoutUserSessions';


//Permissions
export const API_CHECK_PERMISSIONS = API_BASE + '/checkPermissions';
export const API_CHECK_FEDERATED_PERMISSIONS = API_BASE + '/checkFederatedPermissions';
export const API_MAKE_CREDENTIALS = API_BASE + '/makeCredentials';

//Global ID
export const API_REQUEST_GLOBAL_ID = API_BASE + '/requestGlobalId';
export const API_CONFIRM_GLOBAL_ID = API_BASE + '/confirmGlobalId';
export const API_REGISTER_GLOBAL_ID_WITH_COMPANY = API_BASE + '/registerGlobalIdWithCompany';
export const API_CONFIRM_USER_EMAIL = API_BASE + '/confirmUserEmail';
export const API_SEND_OTP_CODE_TO_EMAIL = API_BASE + '/sendOtpCodeToEmail';

//Passwords
export const API_FORGOT_PASSWORD = API_BASE + '/sendForgotPassword';
export const API_CHANGE_USER_PASSWORD = API_BASE + '/changeUserPassword';
export const API_CHECK_PASSWORD = API_BASE + '/checkPwnedPassword';
export const API_GET_SAML_CONFIG_BY_EMAIL_DOMAIN = API_BASE + '/getSamlConfigByEmailDomain';
export const API_SEND_PASSWORD_LESS_OTP = API_BASE + '/sendPasswordLessOtp';

// User Profile
export const API_UPGRADE_SESSION = API_BASE + '/upgradeSession';
export const API_SEND_UPGRADE_CODE = API_BASE + '/sendUpgradeSessionOtpCode';
export const API_SAVE_USER_PROFILE = API_BASE + '/saveUserProfile';
export const API_LOAD_USER_PROFILE = API_BASE + '/getUserContact';
export const API_GET_USER_APP_CONFIGS = API_BASE + '/getUserAppConfigs';
export const API_SAVE_USER_PREFERENCE = API_BASE + '/saveUserPreference';
export const API_GET_ENVIRONMENT = API_BASE + '/getEnvironment';
export const API_LOG_USER_CONNECTION = API_BASE + '/logUserConnection';
export const API_LOG_CONNECTIVITY_TEST_RESULTS = API_BASE + '/logConnectivityTestResults';
export const API_GET_REFERENCE_DATA = API_BASE + '/getReferenceData';
export const API_CONFIRM_PHONE = API_BASE + '/confirmPhone';
export const API_SEND_PHONE_VERIFICATION_CODE = API_BASE + '/sendPhoneVerificationCode';

export const RESOURCES_BASE = ROUTE_BASE + 'ssoreact/resources/';
export const IMAGES_BASE = RESOURCES_BASE + 'images/';
export const IMG_BASE = RESOURCES_BASE + 'img/';
export const IMAGES_VERIFIED_PNG = IMAGES_BASE + 'verified.png';
export const IMAGES_BLANK_PNG = IMAGES_BASE + 'blank.png';
export const IMAGES_GOOGLE_AUTH_HELP_ICON_PNG = IMAGES_BASE + 'sms-help-icon.png';
export const IMAGES_DELETE_ICON_PNG = IMG_BASE + 'delete-icon.png';

export const GOOGLE_RECAPTCHA_V2_SITE_KEY = '6Lez_hgTAAAAAKmAFYR930sS8vMoI_OvG5KDs8v0';
export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'MM-DD-YYYY HH:mm:ss';

export const APP_KEY_GLOBAL = 'GLOBAL';
export const APP_LAUNCHER = 'LAUNCHER';
export const APP_ICEIM = 'iceIM';
export const YES = 'Y';
export const NO = 'N';
export const LOGIN_HELP = "LOGIN_HELP";
export const LOGIN_APP_HEADER = "LOGIN_APP_HEADER";
export const PAGE_PASSWORD_CHANGE_NOTE_ONE = "PAGE_CHANGE_PASSWORD_NOTE_ONE";
export const PAGE_PASSWORD_CHANGE_NOTE_TWO = "PAGE_CHANGE_PASSWORD_NOTE_TWO";
export const USER_INFO_APPS_INSTRUCTIONS = "USER_INFO_APPS_INSTRUCTIONS";
export const PAGE_PLACEHOLDERS = [LOGIN_HELP, LOGIN_APP_HEADER, PAGE_PASSWORD_CHANGE_NOTE_ONE, PAGE_PASSWORD_CHANGE_NOTE_TWO, USER_INFO_APPS_INSTRUCTIONS];

export const ALERT_STYLE_SUCCESS = 'success';
export const ALERT_STYLE_DANGER = 'danger';

//UI Messages
export const REGISTRATION_UI_HEADER = 'REGISTRATION_UI_HEADER';
export const REGISTRATION_UI_INSTRUCTIONS_ONE = 'REGISTRATION_UI_INSTRUCTIONS_ONE';
export const REGISTRATION_UI_INSTRUCTIONS_TWO = 'REGISTRATION_UI_INSTRUCTIONS_TWO';
export const REGISTRATION_UI_CONTACT_INFO = 'REGISTRATION_UI_CONTACT_INFO';
export const REGISTRATION_ADDITIONAL_INFO_HEADER = 'REGISTRATION_ADDITIONAL_INFO_HEADER';
export const REGISTRATION_CONTACT_INFO_HEADER = 'REGISTRATION_CONTACT_INFO_HEADER';
export const REGISTRATION_UI_ROLES_INSTRUCTIONS_ONE = 'REGISTRATION_UI_ROLES_INSTRUCTIONS_ONE';
export const REGISTRATION_UI_ROLES_INSTRUCTIONS_TWO = 'REGISTRATION_UI_ROLES_INSTRUCTIONS_TWO';
export const REGISTRATION_UI_ROLES_CONTENT = 'REGISTRATION_UI_ROLES_CONTENT';
export const REGISTRATION_UI_ROLES_SELECT_CONTENT = 'REGISTRATION_UI_ROLES_SELECT_CONTENT';
export const REGISTRATION_UI_SUMMARY_SELECTED_CONTENT = 'REGISTRATION_UI_SUMMARY_SELECTED_CONTENT';

// Page-specific UI Messages
// Email Info Page
export const REGISTRATION_EMAIL_INFO_INSTRUCTIONS_ONE = 'REGISTRATION_EMAIL_INFO_INSTRUCTIONS_ONE';
export const REGISTRATION_EMAIL_INFO_INSTRUCTIONS_TWO = 'REGISTRATION_EMAIL_INFO_INSTRUCTIONS_TWO';
export const REGISTRATION_EMAIL_INFO_CONTACT_INFO = 'REGISTRATION_EMAIL_INFO_CONTACT_INFO';

// Personal Info Page
export const REGISTRATION_PERSONAL_INFO_INSTRUCTIONS_ONE = 'REGISTRATION_PERSONAL_INFO_INSTRUCTIONS_ONE';
export const REGISTRATION_PERSONAL_INFO_INSTRUCTIONS_TWO = 'REGISTRATION_PERSONAL_INFO_INSTRUCTIONS_TWO';
export const REGISTRATION_PERSONAL_INFO_CONTACT_INFO = 'REGISTRATION_PERSONAL_INFO_CONTACT_INFO';
export const REGISTRATION_IS_API_USER_LABEL = 'REGISTRATION_IS_API_USER_LABEL';

// Roles Selection Page
export const REGISTRATION_ROLES_SELECTION_INSTRUCTIONS_ONE = 'REGISTRATION_ROLES_SELECTION_INSTRUCTIONS_ONE';
export const REGISTRATION_ROLES_SELECTION_INSTRUCTIONS_TWO = 'REGISTRATION_ROLES_SELECTION_INSTRUCTIONS_TWO';
export const REGISTRATION_ROLES_SELECTION_CONTACT_INFO = 'REGISTRATION_ROLES_SELECTION_CONTACT_INFO';

// Confirmation Page
export const REGISTRATION_CONFIRMATION_INSTRUCTIONS_ONE = 'REGISTRATION_CONFIRMATION_INSTRUCTIONS_ONE';
export const REGISTRATION_CONFIRMATION_INSTRUCTIONS_TWO = 'REGISTRATION_CONFIRMATION_INSTRUCTIONS_TWO';
export const REGISTRATION_CONFIRMATION_CONTACT_INFO = 'REGISTRATION_CONFIRMATION_CONTACT_INFO';

export const REGISTRATION_PLACEHOLDERS = [REGISTRATION_UI_HEADER, REGISTRATION_UI_INSTRUCTIONS_ONE,
    REGISTRATION_UI_INSTRUCTIONS_TWO, REGISTRATION_UI_CONTACT_INFO, REGISTRATION_ADDITIONAL_INFO_HEADER, REGISTRATION_UI_ROLES_INSTRUCTIONS_ONE,
    REGISTRATION_UI_ROLES_INSTRUCTIONS_TWO, REGISTRATION_UI_ROLES_CONTENT, REGISTRATION_UI_ROLES_SELECT_CONTENT, REGISTRATION_UI_SUMMARY_SELECTED_CONTENT,
    // Page-specific constants
    REGISTRATION_EMAIL_INFO_INSTRUCTIONS_ONE, REGISTRATION_EMAIL_INFO_INSTRUCTIONS_TWO, REGISTRATION_EMAIL_INFO_CONTACT_INFO,
    REGISTRATION_PERSONAL_INFO_INSTRUCTIONS_ONE, REGISTRATION_PERSONAL_INFO_INSTRUCTIONS_TWO, REGISTRATION_PERSONAL_INFO_CONTACT_INFO,
    REGISTRATION_ROLES_SELECTION_INSTRUCTIONS_ONE, REGISTRATION_ROLES_SELECTION_INSTRUCTIONS_TWO, REGISTRATION_ROLES_SELECTION_CONTACT_INFO,
    REGISTRATION_CONFIRMATION_INSTRUCTIONS_ONE, REGISTRATION_CONFIRMATION_INSTRUCTIONS_TWO, REGISTRATION_CONFIRMATION_CONTACT_INFO, REGISTRATION_CONTACT_INFO_HEADER,
    REGISTRATION_IS_API_USER_LABEL
];

export const API_SAVE_REGISTRATION = API_BASE + '/saveRegistration';
export const API_UPDATE_REGISTRATION = API_BASE + '/updateRegistration';
export const API_ALL_ROLES_BY_APP_KEY = API_BASE + '/getSsoRolesByAppKey';
export const API_GET_ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES = API_BASE + '/getUltimateParentCompanyAllowedRoles';
export const API_REGISTRATION_SEND_EMAIL_CONFIRMATION = API_BASE + '/sendConfirmationCode';
export const API_REGISTRATION_VERIFY_EMAIL_CONFIRMATION_CODE = API_BASE + '/verifyUserRegistrationConfirmationCode';
export const API_EMAIL_2FA_PASSCODE = API_BASE + '/email2FAPasscode';
export const GET_ATTRIBUTES_TYPES = API_BASE + '/getAttributeTypes';
export const API_REGISTRATION_SEND_SESSION_PING = API_BASE + '/refreshSession';
export const USER_ROLES = [
    "Trader",
    "Broker",
    "Sales Trader",
    "Middle Office",
    "Back Office",
    "Risk",
    "Compliance",
    "Treasurer",
    "C-Level",
    "Portfolio Manager",
    "Investor Relations",
    "General Counsel",
    "Clerk",
    "Technology",
    "Other"
];

// added
export const API_VERIFY_EMAIL_CONFIRMATION_CODE = API_BASE + '/verifyEmailConfirmationCode';
export const API_VERIFY_EMAIL_OTP_CODE = API_BASE +'/verifySelfServiceEmailOtp'
export const API_CHANGE_GLOBAL_ID_EMAIL_VALIDATE_DOMAIN = API_BASE + '/changeGlobalIdEmailValidateDomain';
